import {Component, Input, OnDestroy, OnInit} from "@angular/core";
import {
    Aangifte, BokkzAlgDataService, IncomeTaxEntity,
    Periode,
    ReisAftrekOV
} from "@snelstart-ventures/fiscaal/domain-logic";
import {FormArray, FormBuilder, FormGroup} from "@angular/forms";
import { SelectFormControlItem, SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import {BokkzIbDataService} from "@snelstart-ventures/fiscaal/domain-logic";
import { CommonModule, DatePipe } from '@angular/common';
import {BehaviorSubject, filter, Subscription} from "rxjs";
import {Event, NavigationEnd, Router} from "@angular/router";
import { SharedUiButtonModule } from '@snelstart/ui-button';
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { SharedUiAlertModule } from '@snelstart/ui-alert';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-reisaftrek-ov',
  templateUrl: './reisaftrek-ov.component.html',
  styleUrls: ['./reisaftrek-ov.component.scss'],
    imports: [
        SharedUiFormControlsModule,
        SharedUiButtonModule,
        SharedUiDetailsModule,
        CommonModule,
        SharedUiAlertModule
    ],
  providers: [DatePipe]
})
export class ReisaftrekOvComponent implements OnInit, OnDestroy {
    @Input() public id!: string;
    private routerSubscription: Subscription | undefined;
    private incomeTaxEntitySubscription: Subscription | undefined;
    private clientEntitySubscription: Subscription | undefined;
    private isDefAangifteSubscription: Subscription | undefined;

    private isSaving = false;
    public clientId!: string;
    public aangifte = {} as Aangifte;
    public incomeTaxEntity = {} as IncomeTaxEntity;

    public partnerBoolean = {} as boolean;
    @Input() partner = new BehaviorSubject<boolean>(false);
    private partnerAangifte = {} as Aangifte

    public isDefAangifte = {} as boolean;

    private focusedElementId: string | null = null;

    public reisaftrekOv = {} as FormGroup

    public optionsAantalDagen: SelectFormControlItem<number>[] = [
        {value: 1, label: "1 dag"},
        {value: 2, label: "2 dagen"},
        {value: 3, label: "3 dagen"},
        {value: 4, label: "4 dagen"},
        {value: 5, label: "5 dagen"}
    ];

    constructor(public dataService: BokkzIbDataService, public dataAlgService: BokkzAlgDataService,
                private fb: FormBuilder,
                private router: Router) {
        this.reisaftrekOv = this.fb.group({
            reisaftrekOpenbaarVervoer: this.fb.array<ReisAftrekOV>(([] as ReisAftrekOV[]))
        })
    }

    get reisaftrekOpenbaarVervoer(): FormArray {
        return this.reisaftrekOv.get("reisaftrekOpenbaarVervoer") as FormArray;
    }

    addRijReisaftrekOv(): void {
        this.reisaftrekOpenbaarVervoer.push(this.createReisaftrekOvFormGroup())
    }

    verwijderRijReisaftrekOv(index: number): void {
        this.reisaftrekOpenbaarVervoer.removeAt(index);
        this.reisaftrekOv.updateValueAndValidity()
        this.reisaftrekOv.markAsDirty()
        this.saveForm();
    }

    createReisaftrekOvFormGroup(reisAftrekOV?: ReisAftrekOV): FormGroup {
        return this.fb.group(({
            omschrijving: reisAftrekOV ? reisAftrekOV.omschrijving : null as unknown as string,
            periodeVanReizen: this.fb.group<Periode>({
                begindatum: reisAftrekOV ? reisAftrekOV.periodeVanReizen?.begindatum : [new Date(this.aangifte.aangifteJaar, 0, 1, 12, 0, 0)] as unknown as Date,
                einddatum: reisAftrekOV ? reisAftrekOV.periodeVanReizen?.einddatum : [new Date(this.aangifte.aangifteJaar, 11, 31, 12, 0, 0)] as unknown as Date,
            }),
            aantalDagenPerWeek: reisAftrekOV ? reisAftrekOV.aantalDagenPerWeek : null as unknown as number,
            afstandEnkeleReis: reisAftrekOV ? reisAftrekOV.afstandEnkeleReis : null as unknown as number,
            vergoedingWerkgever: reisAftrekOV ? reisAftrekOV.vergoedingWerkgever : null as unknown as number,
        } as ReisAftrekOV));
    }

    public ngOnInit(): void {
        this.isDefAangifteSubscription = this.dataService.isDefAangifte.subscribe((isDefAangifte) => {
            this.isDefAangifte = isDefAangifte;
        });
        this.incomeTaxEntitySubscription = this.dataService.incomeTaxEntity.subscribe((incomeTaxEntity) => {
            this.incomeTaxEntity = incomeTaxEntity;
            if (incomeTaxEntity.aangifte) {
                const aangifte = incomeTaxEntity.aangifte;
                this.aangifte = aangifte;
                this.partnerAangifte = aangifte.partnerAangifte ? aangifte.partnerAangifte : {} as Aangifte;
                this.updateForm();
                this.partner.subscribe((partner) => {
                    this.partnerBoolean = partner
                    this.reisaftrekOv.reset()
                    this.updateForm();
                });
            }
        });
        this.clientEntitySubscription = this.dataAlgService.client.subscribe((client) => {
            this.clientId = client.sstRelationId!;
        })
        this.routerSubscription = this.router.events.pipe(filter((event: Event): event is NavigationEnd => event instanceof NavigationEnd))
            .subscribe((event: NavigationEnd) => {
                this.handleUrlChange(event.urlAfterRedirects);
            });
    }

    ngOnDestroy(): void {
        if (this.routerSubscription) {
            this.routerSubscription.unsubscribe();
        }
        if (this.incomeTaxEntitySubscription) {
            this.incomeTaxEntitySubscription.unsubscribe();
        }
        if (this.clientEntitySubscription) {
            this.clientEntitySubscription.unsubscribe();
        }
        if (this.isDefAangifteSubscription) {
            this.isDefAangifteSubscription.unsubscribe();
        }
    }

    handleUrlChange(newUrl: string) {
        if (!this.isSaving && this.hasUnsavedChanges()) {
            this.isSaving = true;
            this.dataService.postIncomeTaxEntity(this.clientId, false, this.incomeTaxEntity);
            this.isSaving = false;
        }
    }

    private hasUnsavedChanges(): boolean {
        return this.reisaftrekOv.dirty;
    }

    private updateForm(): void {
        let reisaftrekOvLijst = this.aangifte?.box1?.belastbaarLoon?.reisAftrekOV || [];
        this.partner.subscribe((partner) => {
            if (partner) {
                reisaftrekOvLijst = this.aangifte?.partnerAangifte?.box1?.belastbaarLoon?.reisAftrekOV || [];
            }
        });

        const formArray = this.reisaftrekOpenbaarVervoer;
        const focusedControl = this.focusedElementId ? document.getElementById(this.focusedElementId) as HTMLElement : null;

        while (formArray.length > reisaftrekOvLijst.length) {
            formArray.removeAt(formArray.length - 1);
        }

        for (let i = 0; i < reisaftrekOvLijst.length; i++) {
            if (i < formArray.length) {
                const control = formArray.at(i) as FormGroup;
                control.patchValue(reisaftrekOvLijst[i]);
            } else {
                const formGroup = this.createReisaftrekOvFormGroup(reisaftrekOvLijst[i]);
                formArray.push(formGroup);
            }
        }
        if (focusedControl && document.contains(focusedControl)) {
            focusedControl.focus();
        }
    }

    saveForm(): void {
        if (!this.partnerBoolean) {
            this.incomeTaxEntity.aangifte = {
                ...this.aangifte,
                box1: {
                    ...this.aangifte.box1,
                    belastbaarLoon: {
                        ...this.aangifte.box1?.belastbaarLoon,
                        reisAftrekOV: this.reisaftrekOv.value.reisaftrekOpenbaarVervoer
                    }
                }
            } as Aangifte;
            this.dataService.updateIncomeTaxEntity(this.incomeTaxEntity);
        } else {
            this.incomeTaxEntity.aangifte = {
                ...this.aangifte,
                partnerAangifte: {
                    ...this.aangifte.partnerAangifte,
                    box1: {
                        ...this.aangifte.partnerAangifte?.box1,
                        belastbaarLoon: {
                            ...this.aangifte.partnerAangifte?.box1?.belastbaarLoon,
                            reisAftrekOV: this.reisaftrekOv.value.reisaftrekOpenbaarVervoer
                        }
                    },
                },
            } as Aangifte;
            this.dataService.updateIncomeTaxEntity(this.incomeTaxEntity);
        }
        this.reisaftrekOv.markAsDirty()
    }

    public heeftLoondienst(): boolean {
        if (this.partnerBoolean) {
            return !!(this.aangifte &&
                this.aangifte.partnerAangifte &&
                this.aangifte.partnerAangifte.box1 &&
                this.aangifte.partnerAangifte.box1.belastbaarLoon &&
                this.aangifte.partnerAangifte.box1.belastbaarLoon.loonUitTegenwoordigeDienstbetrekking &&
                this.aangifte.partnerAangifte.box1.belastbaarLoon.loonUitTegenwoordigeDienstbetrekking.length > 0);
        } else {
            return !!(this.aangifte &&
                this.aangifte.box1 &&
                this.aangifte.box1.belastbaarLoon &&
                this.aangifte.box1.belastbaarLoon.loonUitTegenwoordigeDienstbetrekking &&
                this.aangifte.box1.belastbaarLoon.loonUitTegenwoordigeDienstbetrekking.length > 0);
        }
    }
}
